import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiWorkspaceAccounts, apiWorkspaceAccountTypes } from "~/routes"
import useFetchResource from "~/hooks/useFetchResource"

import PageContainer from "~/library/PageContainer"
import LoadingWrapper from "~/library/LoadingWrapper"
import AccountForm from "./AccountForm"

type AccountTypeOption = {
    id: string
    name: string
}

const NewAccount = () => {
    const { venueSlug } = getAppConfig()
    const [createdAccountId, setCreatedAccountId] = useState<string | null>(null)
    const toast = useToast()

    const { data: accountTypes, isLoading: typesLoading } = useFetchResource<
    AccountTypeOption[],
    "account_types"
    >(apiWorkspaceAccountTypes.index.path({ venueSlug }), "account_types", {})

    const handleSubmit = (formValues: any) => {
        const data = {
            venue_slug: venueSlug,
            account: formValues,
        }

        const req = apiWorkspaceAccounts.create({ data })

        req
            .then((response) => {
                if (response.status === "ok") {
                    setCreatedAccountId(response.prefixId)
                    toast("Account created successfully", "success")
                } else {
                    toast(
                        `Error creating account. ${response.errors?.join(", ") || "Please try again"}`,
                        "danger"
                    )
                }
            })
            .catch((res) => {
                const errorMessage =
                    res.body?.errors?.join(", ") ||
                    res.body?.error ||
                    "Please try again"
                toast(`Error creating account. ${errorMessage}`, "danger")
            })
    }

    if (createdAccountId) {
        return <Navigate to={`/accounts/${createdAccountId}`} />
    }

    return (
        <PageContainer>
            <LoadingWrapper isLoading={typesLoading}>
                <div className="row h-100">
                    <div className="col-8 offset-2 align-center mt-4">
                        <h3 className="mb-3">New Account</h3>
                        {accountTypes && (
                            <AccountForm onSubmit={handleSubmit} accountTypes={accountTypes} />
                        )}
                    </div>
                </div>
            </LoadingWrapper>
        </PageContainer>
    )
}

export default NewAccount
